//所有请求接口
import {
	axios
} from './server';
// 首页数据
function getHomeData() {
	return axios.get('/getHomeData');
}
// 产品品牌
function getBrandList() {
	return axios.get('/getBrandList');
}
// 核心产品(分页)
function getGoodPage(data) {
	return axios.get('/getGoodPage', data);
}
// 产品详情
function getGoodDetails(data) {
	return axios.get('/getGoodDetails', data);
}
// 人才招聘
function getRecruit() {
	return axios.get('/getRecruit');
}
// 新闻动态
function getNews(data) {
	return axios.get('/getNewPage',data);
}
// 新闻动态详情
function getNewsDetails(data) {
	return axios.get('/getNewsDetails', data);
}
// 联系我们
function getContactUs() {
	return axios.get('/getContactUs');
}
// getHeadBanner
function getHeadBanner() {
	return axios.get('/getHeadBanner');
}
//获取友情链接
function getFriends() {
	return axios.get('/gpBlogroll')
}
//获取首页关于我们公司信息
function getAboutMeData() {
	return axios.get('/gpCompanyIntro')
}
//首页产品中心
function getHomeProducts() {
	return axios.get('/getGoodPage')
}
//提交购物车
// function postCart(data) {
// 	return axios.post('shop/cart',data);
// }
//联系我们验证码
function getCode() {
	return axios.get('/captchaImage')
}
//联系我们页面反馈问题
function submitData(data) {
	return axios.get('/saveContactUs', data)
}
//合作伙伴
function getPartners() {
	return axios.get('/gpBusinessPartners')
}
//首页获取证书
function getCertificate(data) {
	return axios.get('/gpHonorsCertificate',data)
}
//首页获取新闻
function getHomeNews() {
	return axios.get('/getNews')
}
//获取关于我们企业宗旨
function gpCompanyMission() {
	return axios.get('/gpCompanyMission')
}
//企业风采照片
function gpCompanyPhotosForm() {
	return axios.get('/gpCompanyPhotosForm')
}
//后市场板块
function getMarketPage(data) {
	return axios.get('/getMarketPage',data)
}
//服务支持详情
function getServeDetails(data) {
	return axios.get('/getServeDetails',data)
}
//沥拌
function getAsphaltPage(data) {
	return axios.get('/getAsphaltPage',data)
}
//查看详情
function getAsphaltDetails(data) {
	return axios.get('/getAsphaltDetails',data)
}
//参建项目
function getAttendList(data) {
	return axios.get('/getAttendList',data)
}
//施工
function getConstructionPage(data) {
	return axios.get('/getConstructionPage',data)
}
//施工详情
function getConstructionDetails(data) {
	return axios.get('/getConstructionDetails',data)
}
//工程案例
function getCasePage(data) {
	return axios.get('/getCasePage',data)
}
//工程案例详情
function getCaseDetails(data) {
	return axios.get('/getCaseDetails',data)
}
//timeLine
function getPerformanceList(data) {
	return axios.get('/getPerformanceList',data)
}
//全局搜索
function control(data) {
	return axios.get('/control',data)
}
export {
	getHomeData,
	getGoodPage,
	getGoodDetails,
	getRecruit,
	getNews,
	getNewsDetails,
	getBrandList,
	getContactUs,
	getHeadBanner,
	getFriends,
	getAboutMeData,
	getHomeProducts,
	getCode,
	submitData,
	getPartners,
	getCertificate,
	getHomeNews,
	gpCompanyMission,
	gpCompanyPhotosForm,
	getMarketPage,
	getAsphaltPage,
	getAsphaltDetails,
	getServeDetails,
	getAttendList,
	getConstructionPage,
	getConstructionDetails,
	getCasePage,
	getCaseDetails,
	getPerformanceList,
	control
}
